import { useTranslation } from "@coworker/locales";
import FixaButton from "../../../shared/wrappers/FixaButton/FixaButton";
import { FixaText } from "../../../shared/wrappers/FixaText/FixaText";
import { joinClassNames } from "../utils";
import styles from "./media-publication-info.module.css";

type MediaPublicationInfoProps = {
  published: boolean;
  publishedDate: string;
  onPublishToggle?: () => void;
};

export const MediaPublicationInfo = ({
  published,
  publishedDate,
  onPublishToggle,
}: MediaPublicationInfoProps) => {
  const { t } = useTranslation();
  const statusText = published ? t("publishedString") : t("unpublishedString");
  const actionText = published ? t("unpublishString") : t("publishString");

  return (
    <section
      className={styles["publicationInfo"]}
      aria-label={t("publicationString")}
    >
      <div className={styles["publicationActions"]}>
        <FixaText
          className={joinClassNames(
            styles["status"],
            published ? styles["published"] : styles["unpublished"]
          )}
          tagName={"p"}
        >
          <span className={styles["statusIndicator"]} aria-hidden="true" />
          <span>{statusText}</span>
        </FixaText>

        <FixaButton
          htmlType="button"
          text={actionText}
          size={"small"}
          type="secondary"
          onClick={onPublishToggle}
        />
      </div>

      {published && (
        <FixaText className={styles["publishedDate"]}>
          {t("publishedDateString", { date: publishedDate })}
        </FixaText>
      )}
    </section>
  );
};
